/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl-next';

import { cssMap, jsx } from '@atlaskit/css';
import InfoIcon from '@atlaskit/icon/core/status-information';
import Lozenge from '@atlaskit/lozenge';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import AtlassianIntelligenceIcon from '../../atlassian-intelligence-icon';
import { messages } from '../messages';

const styles = cssMap({
	root: {
		borderTopWidth: token('border.width'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
		paddingBlock: token('space.050'),
		paddingInline: token('space.200'),
		display: 'flex',
		justifyContent: 'space-between',
	},
});

export const AITopicsFooter = () => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.root} testId="ai-topics-footer">
			<Inline alignBlock="center" space="space.050">
				<Lozenge>{formatMessage(messages.ai_topics_surface_footer_beta_lozenge)}</Lozenge>
				<InfoIcon color={token('color.icon')} label="" spacing="compact" size="small" />
				<Text size="small" color="color.text.subtlest">
					{formatMessage(messages.ai_topics_surface_footer_content_may_vary)}
				</Text>
			</Inline>
			<Inline alignBlock="center" alignInline="center" space="space.050">
				<Text size="small" color="color.text.subtlest">
					{formatMessage(messages.ai_topics_surface_footer_powered_by_ai)}
				</Text>
				<AtlassianIntelligenceIcon greyed />
			</Inline>
		</Box>
	);
};
